import { render, staticRenderFns } from "./basepeople.vue?vue&type=template&id=60627fe9&scoped=true"
import script from "./basepeople.vue?vue&type=script&lang=js"
export * from "./basepeople.vue?vue&type=script&lang=js"
import style0 from "./basepeople.vue?vue&type=style&index=0&id=60627fe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60627fe9",
  null
  
)

export default component.exports